// extracted by mini-css-extract-plugin
module.exports = {"title-editor":"TitleEditor_title-editor__3-gvb"};